import { outputAst } from '@angular/compiler';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HistoryBean } from '../model/HistoryBean';

@Component({
  selector: 'app-delegation-history',
  templateUrl: './delegation-history.component.html',
  styleUrls: ['./delegation-history.component.css']
})
export class DelegationHistoryComponent {

  @Input() history: HistoryBean[];
  @Output() cancelEvent = new EventEmitter<boolean>();
  sortField: string;

  ngOnInit() {
    this.sortField = 'changeTime';
  }

  getRecordStatus(type : any)
  {
    if(type == "I")
      return "tilføjet af";
    else if(type == "D")
      return "slettet af";
    else if(type == "U")
      return "redigeret af";
    else return "";
  }

  backClicked(){
    this.cancelEvent.emit(true);
  }
}
